// import componentMixin from './mixin'
var componentDef = {
  template: "<component :is=\"dynamicComponent\" :vc=\"vc\" :template=\"template\" />",
  props: ['vc', 'template'],
  computed: {
    dynamicComponent: function dynamicComponent() {
      return {
        // mixins: [componentMixin],
        props: ['vc', 'template'],
        template: "".concat(this.template || '<div></div>')
      };
    }
  }
};
export default componentDef;